import { useEffect, useState } from "react";

function FilterDropdown({ column }) {
    const [open, setOpen] = useState(false);

    const uniqueValues = Array.from(
        column.getFacetedUniqueValues().keys()
    );

    // 🔹 temp state (checkbox selection)
    const [tempValues, setTempValues] = useState(
        column.getFilterValue() || []
    );

    // 🔹 sync when column filter changes from outside
    useEffect(() => {
        setTempValues(column.getFilterValue() || []);
    }, [column.getFilterValue()]);

    const toggleValue = value => {
        setTempValues(prev =>
            prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value]
        );
    };

    const handleApply = () => {
        column.setFilterValue(
            tempValues.length ? tempValues : undefined
        );
        setOpen(false);
    };

    const handleReset = () => {
        setTempValues([]);
        column.setFilterValue(undefined);
        setOpen(false);
    };

    return (
        <div style={{ position: "relative" }}>
            <span
                style={{ cursor: "pointer" }}
                onClick={() => setOpen(prev => !prev)}
            >
                🔽
            </span>

            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        background: "#fff",
                        border: "1px solid #ccc",
                        padding: "8px",
                        zIndex: 10,
                        width: '400px',
                        maxHeight: "200px",
                        overflow: 'scroll'
                    }}
                >
                    {/* Values */}
                    {uniqueValues.map(value => (
                        <label key={value} style={{ display: "block" }}>
                            <input
                                type="checkbox"
                                checked={tempValues.includes(value)}
                                onChange={() => toggleValue(value)}
                            />
                            {value}
                        </label>
                    ))}

                    {/* Buttons */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "8px",
                        }}
                    >
                        <button onClick={handleReset}>Reset</button>
                        <button onClick={handleApply}>Apply</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FilterDropdown;
